import React, { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { removeHomeBannerAd } from '../lib/admobService';
import '../csscomponent/AdSense.css';

/**
 * In-Page Content Ad:
 * - Rendered strictly INSIDE the page body/content.
 * - Never floats over the Header/Logo or Bottom Navigation.
 * - Scrolls naturally with user scrolling.
 */
export default function AdMobBanner({
  className = '',
  title = 'Featured Partner',
  subtitle = 'Services & Development Sponsored Solutions',
}) {
  const isNative = Capacitor.isNativePlatform();

  useEffect(() => {
    // Kill any floating native overlay so header and bottom menu stay 100% clean
    if (isNative) {
      removeHomeBannerAd();
    }
  }, [isNative]);

  return (
    <div className={`admob-banner-container ${className}`.trim()} aria-label="Advertisement">
      <div className="admob-banner-card in-page-ad-card">
        <div className="admob-policy-badge">
          <span>ADVERTISEMENT</span>
        </div>
        <div className="admob-banner-content">
          <p className="admob-banner-tagline">{title}</p>
          <span className="admob-banner-helper">{subtitle}</span>
        </div>
      </div>
    </div>
  );
}
